export default "__VITE_ASSET__DprapG3A__"